/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import IconButtons from "./IconButtons";
import { Flex } from "@aws-amplify/ui-react";
export default function IconBg(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="10px"
      direction="row"
      width="62px"
      height="68.62px"
      justifyContent="center"
      alignItems="center"
      position="relative"
      boxShadow="2px 2px 4px rgba(0, 0, 0, 0.20999999344348907)"
      borderRadius="4px"
      padding="20px 20px 20px 20px"
      backgroundColor="rgba(242,97,95,1)"
      {...getOverrideProps(overrides, "IconBg")}
      {...rest}
    >
      <IconButtons
        width="24px"
        height="24px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        overflow="hidden"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        variant="iconGrupo"
        {...getOverrideProps(overrides, "iconButtons")}
      ></IconButtons>
    </Flex>
  );
}
